import Const from 'constants';

function resolveExposuresOverlap(exposures, baseDirection) {
    if ('min' === baseDirection) {
        return resolveMinExposureOverlap(exposures);
    }
    return resolveMaxExposureOverlap(exposures);
}

function resolveMinExposureOverlap(exposures) {
    let max = exposures.max;
    if (exposures.min > exposures.max) {
        max = Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE;
    }
    return {...exposures, max};
}

function resolveMaxExposureOverlap(exposures) {
    let min = exposures.min;
    if (exposures.min > exposures.max) {
        min = Const.DEFAULT_VALUE_FOR_MIN_EXPOSURE;
    }
    return {...exposures, min};
}

export {resolveExposuresOverlap};
